import { CustomControlModel } from '@shared/models/devices/CustomControlModel';
import { AllLicenseTypes } from '@shared/models/organizations/AllLicenseTypes';
import { LicenseKeyCheckResponse } from '@shared/models/organizations/LicenseKeyCheckResponse';
import { ProductModel } from '@shared/models/product/ProductModel';
import OrganizationModel from '../../models/organizations/OrganizationModel';

export const getLicenseType = (
    organization: OrganizationModel | ProductModel | LicenseKeyCheckResponse | null
): AllLicenseTypes => {
    if (!organization) {
        return 'personal';
    }
    // professional licenses
    if (organization.isEmployeeAccess) {
        return 'isEmployeeAccess';
    }
    if (organization.isDeveloperAccess) {
        return 'isDeveloperAccess';
    }
    if (organization.isStudentAccess) {
        return 'isStudentAccess';
    }
    if (organization.isPlusAccess) {
        return 'isPlusAccess';
    }

    // default placeholder, in case it is unrecognized license type
    return 'isEmployeeAccess';
};
